import React from 'react';
import Icon from '@ant-design/icons';

const TrashSVG = () => (
  <svg
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden={true}
  >
    <title>Icon / Trash</title>
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Icon-/-Trash" stroke="currentColor">
        <line
          x1="1"
          y1="3.5"
          x2="15"
          y2="3.5"
          id="Line-"
          strokeLinecap="round"
        />
        <line
          x1="5.5"
          y1="1"
          x2="10.5"
          y2="1"
          id="Line"
          strokeLinecap="round"
        />
        <polygon
          id="Path"
          strokeLinejoin="round"
          points="13.9542196 3.5 12.0774871 15 4.00020042 15 1.95421957 3.5"
        />
      </g>
    </g>
  </svg>
);

export const JTrash: React.FC<any> = ({ className, ...props }) => {
  return (
    <Icon
        aria-hidden={true}
      component={TrashSVG}
      className={`hover:text-red${className ? ' ' + className : ''}`}
      {...props}
    />
  );
};
